import { RouteEntry } from "../../shared/routes";
import { IdentityRoles } from "../../configure/security/IdentityRoles";
import { EditQuestionModal } from "./editQuestionModal/EditQuestionModal";

export const questionRoutes: Array<RouteEntry> = [
    { path: '/manage/questions/edit/:id', component: EditQuestionModal, authorize: true, requireRole: IdentityRoles.SubscriptionAdministration },
];
